import { Component, OnInit } from "@angular/core";
import { CutoffService } from "../../services/cutoff.service";
import { TicketCutoffResume } from "../cutoff/ticket-cutoff-type.model";
import { AccountManager } from "../../model/domain/AccountManager";
import { TicketService } from "../../services/ticket.service";
import { SecurityService } from "../../services/security.service";
import { Fund } from "../../model/domain/Fund";
import {
  faPhoneSquare,
  faEnvelopeSquare,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-limit-hours",
  templateUrl: "./limit-hours.component.html",
  styleUrls: ["./limit-hours.component.scss"],
})
export class LimitHoursComponent implements OnInit {
  constructor(
    private cutoffService: CutoffService,
    private ticketService: TicketService,
    private securityService: SecurityService
  ) {}

  resume: Array<TicketCutoffResume>;

  phone: string;
  tel_href_type = "tel:";
  email: string;
  email_href_type = "mailto:";

  accountManagerListAll: AccountManager[];
  accountManagerRegisteredList: AccountManager[];
  accountManagerListToFilter: AccountManager[];
  accountManagerIdList: number[] = [];

  fundListAll: Fund[];
  fundRegisteredList: Fund[];
  fundListToFilter: Fund[];

  faPhoneSquare = faPhoneSquare;
  faEnvelopeSquare = faEnvelopeSquare;

  ngOnInit() {
    this.securityService.GetAccountManagers().subscribe((res) => {
      this.accountManagerListAll = res;

      this.getLimitHours();
      this.setContact();
    });
  }

  setContact() {
    this.phone = "+55 11 3113-0060";
    this.email = "suporte_boletagem@indigodtvm.com.br";
  }

  getLimitHours() {
    this.cutoffService
      .listResumeIndex()
      .subscribe((data: Array<TicketCutoffResume>) => {
        this.resume = data;

        for (const item of this.resume) {
          if (item.accountManagerId) {
            this.accountManagerIdList.push(item.accountManagerId);

            const accountManager = this.accountManagerListAll.find(
              (x) => x.id === item.accountManagerId
            );
            if (this.accountManagerRegisteredList == null) {
              this.accountManagerRegisteredList = [];
            }
            if (
              !this.accountManagerRegisteredList.some(
                (x) => x.id === accountManager.id
              )
            ) {
              this.accountManagerRegisteredList.push(accountManager);
            }

            item.accountManagerName = accountManager.name;
          }
        }

        this.accountManagerListToFilter = this.accountManagerRegisteredList;

        this.ticketService
          .getFundsByAccountManagerIdList(this.accountManagerIdList)
          .subscribe((result) => {
            this.fundListAll = result;
            for (const item of this.resume) {
              if (item.fundId != null) {
                const fund = this.fundListAll.find((x) => x.id === item.fundId);

                if (this.fundRegisteredList == null) {
                  this.fundRegisteredList = [];
                }

                this.fundRegisteredList.push(fund);

                item.fundName = fund.name;
              }
            }
            this.fundListToFilter = this.fundRegisteredList;
          });
      });
  }
}
